module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/03-c70c24010171fcd75317f4fd247f743f.jpg";